import { UtilService } from './../../share/util/util.service';
import { Component, OnInit } from '@angular/core';
import { AuthenticateService } from '../../share/authenticate/authenticate.service';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { ValidationService } from '../../share/validation/validation.service';
import { REGEXP } from '../../share/validation/regexp';
import * as MSG from '../../share/msg/msg';
import { MsgService } from '../../share/msg/msg.service';

@Component({
  selector: 'app-pwchange',
  templateUrl: './pwchange.component.html',
  styleUrls: ['./pwchange.component.css']
})
export class PwchangeComponent implements OnInit {
  // ラベル名
  labelPageTitle = 'パスワード変更';
  labelOldPass = '現在のパスワード';
  labelNewPass = '新しいパスワード';
  labelNewPassConfirm = '新しいパスワードの確認';
  // 各フォーム毎にプロパティを設定。
  // Validationを"Validators.XXX"で指定する。(検証についてはモデル駆動型フォームを採用)
  oldPass = new FormControl('', [
    Validators.required,
    Validators.minLength(8)
  ]);
  newPass = new FormControl('', [
    Validators.required,
    Validators.minLength(8)
  ]);
  newPassConfirm = new FormControl('', [
    Validators.required,
    Validators.minLength(8)
  ]);
  // Formタグ毎にFormGroupオブジェクト生成
  passGroup = this.builder.group({
    oldPass: this.oldPass,
    newPass: this.newPass,
    newPassConfirm: this.newPassConfirm
  });
  /** input type */
  oldPassType = 'password';
  newPassType = 'password';
  newPassConfirmType = 'password';

  constructor(
    private utilServ: UtilService,
    public authServ: AuthenticateService,
    private builder: FormBuilder,
    public validationServ: ValidationService,
    public msgServ: MsgService,
  ) { }

  ngOnInit() {
    this.utilServ.uUI.setTitleBar(this.labelPageTitle);
  }

  public clickChangePassword() {
    if (this.validaitonBeforeUpdate()) {
      return;
    }
    this.authServ.changePassword(this.oldPass.value, this.newPass.value);
  }

    /** フォーム値の検証。
    * @return {boolean} return = true ならば、データ更新しない
  */
 private validaitonBeforeUpdate(): boolean {
    this.validationServ.validationInvalid = false;

    this.oldPass.markAsDirty();
    this.validationServ.formValidation(this.oldPass, this.labelOldPass);

    this.newPass.markAsDirty();
    this.validationServ.formValidation(this.newPass, this.labelNewPass);

    this.newPassConfirm.markAsDirty();
    this.validationServ.formValidation(this.newPassConfirm, this.labelNewPassConfirm);
    /** 新パスワードと確認パスワードの一致確認 */
    if (!this.validationServ.validationInvalid) {
      if (this.newPass.value !== this.newPassConfirm.value) {
        this.newPassConfirm.setErrors({'notEqual2Passwords': true});
        this.msgServ.warning(MSG.WARNING.TWO_PASSWORD_DIFFERENT, '');
        this.validationServ.validationInvalid = true;
      }
    }

    return this.validationServ.validationInvalid;
  }
}
